import { http } from 'src/core/services/http';

export const getPaymentTerms = () => http.get('/common/systemTypes/paymentTerms').then(response => response.data);
